import React from 'react';
import { ExpandLess, ExpandMore } from '@material-ui/icons';

import { ExpandableCommonProps } from 'components/Expandable/types';

export const ExpandableArrow: React.FC<ExpandableCommonProps> = ({ isExpanded }) =>
  isExpanded ? <ExpandLess /> : <ExpandMore />;
